import { gql } from '@common/hooks';
import { OrganizationUnitType } from '@institutions/graphql';

export const WorksMembershipByEmailQuery = gql`
  query WorksMembershipByEmail(
    $email: String!
    $includeWorkers: Boolean
    $workerFirst: Boolean
  ) {
    worksMembershipByEmail(
      email: $email
      includeWorkers: $includeWorkers
      workerFirst: $workerFirst
    ) {
      id
      firstName
      lastName
      email
      employeeId
      role
      timeZone
      title
      phone
      updatedAt
      canUserUpdateMembership
      organizationBusinessesActiveCount
      organizationUnitsActive {
        id
        name
        department {
          id
          organizationBusiness {
            id
            name
          }
        }
        clinicalUnit {
          id
          displayName
        }
        costCenter
        visible
      }
    }
  }
`;

export type WorksMembershipByEmailResponse = {
  worksMembershipByEmail: MembershipByEmail;
};

export type MembershipByEmail = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  employeeId: string;
  role: string;
  timeZone: string;
  title?: string;
  phone: string;
  updatedAt: string;
  canUserUpdateMembership: boolean;
  organizationBusinessesActiveCount: number;
  organizationUnitsActive: MembershipOrganizationUnit[];
} | null;

export type MembershipOrganizationUnit = OrganizationUnitType & {
  visible: boolean;
};
